import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getClasses = ({ dsf_size, dsf_no_underline, disabled }) => {
  const classes = [
    "flex-auto",
    "inline-flex",
    "gap-4",
    "border-0",
    "underline",
    "rounded-xs",
    "outline-none",
    "items-center"
  ];
  if (disabled) {
    classes.push("text-neutral-200");
  } else {
    classes.push("cursor-pointer");
    classes.push("text-secondary-300");
    classes.push("hover:text-secondary-400");
    classes.push("focus:bg-secondary-50");
  }
  if (dsf_size === "small") {
    classes.push("dsf-text-xxs");
    classes.push("focus-visible:shadow-focus-secondary-sm");
  } else if (dsf_size === "medium") {
    classes.push("dsf-text-xs");
    classes.push("focus-visible:shadow-focus-secondary-md");
  } else {
    classes.push("dsf-text-s");
    classes.push("focus-visible:shadow-focus-secondary-md");
  }
  if (dsf_no_underline) {
    classes.push("no-underline");
  }
  return concatClasses(classes);
};
const getIconClasses = ({ dsf_size }) => {
  const classes = ["mt-2"];
  if (dsf_size === "small") {
    classes.push("h-12", "w-12");
  } else {
    classes.push("h-14", "w-14");
  }
  return concatClasses(classes);
};
export {
  getClasses,
  getIconClasses
};
